import React from 'react';
import { routes } from 'app/constants';
import { Redirect } from 'react-router-dom';
import propTypes from 'prop-types';

export default function BaseLoginRedirectPage({ redirectTo = routes.home }) {
  return <Redirect to={redirectTo} />;
}

BaseLoginRedirectPage.propTypes = {
  redirectTo: propTypes.string,
};
